let React              = require("react");
let Thumbnail          = require("./Thumbnail.jsx");   
let SwitchThumbnail    = require("./SwitchThumbnail.jsx");
let CircuitsUtil       = require("../../util/CircuitsUtil.js");
let ApplicationContext = require("../../config/ApplicationContext.js");

class ThumbnailLinkWithSwitcher extends React.Component {

	render(){
        const { 
            Action, 
            objUrl, 
            isTrash,
            resource,
            InfoOverlay,
            requireVersion, 
            showInfoOverlay, 
            switchThumbnail, 
            showOwner = true,
            isPublicFacing = false,
            layout,
						thumbnailUseResource = false
        } = this.props;
        
        let { hasVersions = false, thumbnail: thumbnailSrc } = resource;

        if(requireVersion && CircuitsUtil.getMostRecentVersion(resource) === -1 ) {
            thumbnailSrc = `${ApplicationContext.assetUrlPrefix}/assets/icons/icon-no-image.svg`;
        }

        let properties = resource.properties || {};

        let hasSwitcherMargin = layout == "list" && (switchThumbnail.show || isTrash);
        let noCursor = !isPublicFacing && !resource.objStatus || resource.objStatus === "failed"? "noCursor": "";
        
		return <div className={`card__item card__image ${hasSwitcherMargin? "switch": ""} ${noCursor}`}>
            <SwitchThumbnail {...switchThumbnail} 
                Action={Action}
                id={resource.id} 
                objUrl={objUrl}
                showOwner={showOwner}
                hasVersions={hasVersions}
                addedClass = "visibleByHover" 
                ByDefault={() =>
                    <Action Content={()=>
                            <Thumbnail
                                src={thumbnailSrc} 
                                alt={`${resource.name}\n${resource.summary}`} 
                            />}
                    />}
            />
            
            { InfoOverlay && 
                    <InfoOverlay show={showInfoOverlay} data={properties}/>}                        
        </div>
	}
}

module.exports = ThumbnailLinkWithSwitcher;
